<div class="get-link-1" (click)="openModal()">
  <span class="get-link">
    <img
      src="../../../../assets/images/Icon-step.svg"
      width="20"
      height="20"
      alt=""
    />
    <span>首次登入必看帮助</span>
  </span>
</div>
<div class="get-link-2">
  <ng-container *ngIf="timeout === 91 && !link">
    <img
      src="../../../assets/images/Icon-link.svg"
      alt="link"
      width="20"
      height="20"
    />
    <span (click)="openTip()">点击获取验证码</span>
  </ng-container>
  <ng-container *ngIf="timeout !== 0 && timeout !== 91 && !link">
    <img
      src="../../../assets/images/Icon-link.svg"
      alt="link"
      width="20"
      height="20"
    />
    <span
      style="color: #909090; text-decoration-line: underline; cursor: default"
    >
      查询正在进行中…({{ timeout }})秒
    </span>
  </ng-container>
  <ng-container *ngIf="timeout === 0 && !link">
    <mat-icon>refresh</mat-icon>
    <span class="again" (click)="refresh()"> 重试 </span>
  </ng-container>
  <ng-container *ngIf="link">
    <img
      src="../../../assets/images/Icon-link.svg"
      alt="link"
      width="20"
      height="20"
    />
    <span class="link">
      {{ link }}
    </span>
  </ng-container>
</div>
<div class="get-link-2" (click)="openTeamModal()" style="margin-top: 5px">
  <img
    src="../../../../assets/images/Icon-check.png"
    width="20"
    height="20"
    alt=""
  />
  <span>查看最新有效团队</span>
</div>
